import { Loading } from '@octano/global-ui';
import { ReactNode } from 'react';
import { useWarningsSummaryDetailsLoader } from '../loaders/StudentWarningsSummaryDetailsLoader';
import { StudentWarningsGroupType } from '../types';
import AcademicWarningGroup from './WarningGroups/AcademicWarningGroup';
import BehaviorWarningGroup from './WarningGroups/BehaviorWarningGroup';
import HealthWarningGroup from './WarningGroups/HealthWarningGroup';

const TAB_COMPONENTS: Record<StudentWarningsGroupType, ReactNode> = {
  [StudentWarningsGroupType.Academic]: <AcademicWarningGroup />,
  [StudentWarningsGroupType.Health]: <HealthWarningGroup />,
  [StudentWarningsGroupType.Behavior]: <BehaviorWarningGroup />,
};

const StudentWarningsSummaryDetailsSwitch = () => {
  const { query, loading } = useWarningsSummaryDetailsLoader();

  if (!query?.warningGroupType) {
    return <></>;
  }

  if (loading) {
    return (
      <div className="w-100 d-flex flex-wrap justify-content-center">
        <Loading textBody={''} />
      </div>
    );
  }

  return (
    <div className="w-100 d-flex flex-wrap justify-content-center">
      {TAB_COMPONENTS[query?.warningGroupType]}
    </div>
  );
};

export default StudentWarningsSummaryDetailsSwitch;
